import { AbstractControl } from '@angular/forms';

export function ValidateExtension(extensions: string[]) {

    
    
    return (control: AbstractControl) => {

        var name = control.value;
        // console.log(name);
        var exts = name.substring(name.lastIndexOf('.') + 1).toLowerCase();

        if (name && extensions.indexOf(exts) < 0)
            return { validExt: true };
        else
            return null;
    };
}